export default "__VITE_ASSET__NOU1taur__"